import { useNavigate } from "react-router";
import { WxTitle } from "../components";
import { ProductCard } from "../components/pages/category/ProductCard";
import { ProductsWrapper } from "../components/pages/category/Products";
import { EmptyPlaceholder } from "../components/ui/notFound/EmptyPlaceholder";
import useFavoriteProducts from "../hooks/api/queries/useFavoriteProducts";
import useJwt from "../hooks/utils/useJwt";
import { __ } from "../i18n/l10n";
import { appendCommitHash } from "../utils/appendHash";
import { PageWrapper } from "./Category";

export const Favorites = () => {
  const { data, isLoading } = useFavoriteProducts();
  const navigate = useNavigate();
  const jwt = useJwt();

  if (!jwt) navigate(appendCommitHash("/"));

  return (
    <PageWrapper>
      <WxTitle title={__("Favourites")} size="big" darkMode />
      {!isLoading &&
        ((data?.results?.length ?? 0) > 0 ? (
          <ProductsWrapper>
            {data?.results.map((product, index) => (
              <li key={index}>
                <ProductCard product={product} />
              </li>
            ))}
          </ProductsWrapper>
        ) : (
          <EmptyPlaceholder type="favorites" />
        ))}
    </PageWrapper>
  );
};
